var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-log-container"},[_c('div',{staticClass:"title"},[_vm._v("待更新日志"),_c('span',[_vm._v("（"+_vm._s(_vm.time)+"）")])]),_c('ul',_vm._l((_vm.contentInformation),function(item,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }